<template>
  <w-modal
    v-model="show"
    :submit-button="$t('buttons.save')"
    :title="$t(title)"
    :close-button="$t('buttons.cancel')"
    :close-on-submit="false"
    :hideOnOverlay="false"
    :hideOnEsc="false"
    @submit="saveTeam()"
    @close="close()"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" :title="$t($schema.name.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <w-select
          :placeholder="$t('modals.chooseDiscipline')"
          :model="$schema.sportId"
          :values="sports"
          :title="$t($schema.sportId.$schema.title)"
        />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/team.schema';

const emptyData = () => ({
  name: '',
  clubId: null,
  sportId: null
});

// @vuese
// Modal grupy treningowej
// @group Club
export default {
  mixins: [manageMixin('team', {}, emptyData)],
  schema,
  props: {
    clubId: {
      type: Number,
      required: true
    }
  },
  methods: {
    // @vuese
    // Zapisuje zaspół
    saveTeam() {
      this.$schema.clubId.$model = this.clubId;
      this.save();
    }
  },
  created() {
    this.$store.dispatch(`sport/list`);
  },
  computed: {
    ...mapState({
      sports: state => state.sport.list.map(item => ({ value: item.id, text: item.name })),
      stateData: state => {
        return { ...state.team.data, sportId: state.team.data.sport.id };
      }
    }),
    title() {
      return this.id ? 'modals.team-edit' : 'modals.team-add';
    }
  }
};
</script>
